import { curryN } from 'ramda';
import * as most from 'most';

const curry2 = curryN(2);

export const map = curry2(most.map);



// WEBPACK FOOTER //
// ./src/crosscutting/mostc.js